// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React, { memo } from 'react';
import HotspotMedia from '../../common/ImageHotspot/HotspotMedia';
import { useDisplayWidgetContext } from '../DisplayWidget/utils/context';
import GoogleBadgeDesign from '../GoogleBadgeDesign';
import { UseWindowDimensions } from '../collage/utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import AiSummaryCard from '../AiSummaryCard';
import { CLICK_EVENTS, SOURCE_TYPES } from '../../contants';

const ProductOutside = React.lazy(() => import('../Modals/components/ProductOutside'));
const ProductOutsideUp = React.lazy(() => import('../Modals/components/ProductOutsideUp'));

const LinkedinView = React.lazy(() => import('../LinkedinView'));
const GoogleView = React.lazy(() => import('../GoogleView'));

const CarouselTwo = () => {
  const {
    showModal,
    albumData,
    clickMutate,
    setAlbumId,
    isGoogle,
    layout,
    shopifyData,
    isLinkedIn,
    setIsUploadModalOpen,
    fetchNextPost,
    isLoading,
    data,
  } = useDisplayWidgetContext();
  const galleryData = data?.result?.layout;

  const [activeIndex, setActiveIndex] = React.useState(0);

  const swiperRef = React.useRef(null); // Keep Swiper instance
  const lastRealIndexRef = React.useRef(0);

  const handleSlideChange = (swiper) => {
    const realIndex = swiper.realIndex;
    lastRealIndexRef.current = realIndex;
    setActiveIndex(realIndex);

    if (realIndex === albumData.length - 4 && !isLoading) {
      fetchNextPost();
    }
  };

  React.useEffect(() => {
    if (swiperRef.current && albumData.length > 0) {
      swiperRef.current.slideToLoop(lastRealIndexRef.current);
    }
  }, [albumData.length]);

  React.useEffect(() => {
    if (layout?.sliderSettings?.specialCarousel) {
      if (layout?.sliderSettings?.specialCarousel) {
        const container = document.getElementsByClassName('Idukki-App')[0];
        if (container) {
          const videos = container.querySelectorAll('video');
          videos.forEach((video) => {
            video.pause();
          });
        }
        const currentVideoElement = container
          .querySelector(`[id="slide_${activeIndex}"]`)
          ?.getElementsByTagName('video');
        if (currentVideoElement?.length > 0) {
          currentVideoElement?.[0].play();
        }
      }
    }
  }, [activeIndex]);

  const { width: screenWidth } = UseWindowDimensions();
  const mobileView = screenWidth < 500;

  if (isGoogle) {
    return (
      <React.Fragment>
        <style>{`
      .idk-carousel2-item{
        padding: 0 ${parseInt(layout?.galleryInformation?.postSpacing) / 2}px;
      }`}</style>
        <idk-div
          style={{
            gap: `${layout?.galleryInformation?.postSpacing}px`,
          }}
        >
          {isGoogle && (
            <idk-div
              style={{
                flexGrow: 1,
                height: '100%',
              }}
            >
              <GoogleBadgeDesign metaJson={data?.result?.metaJson} />
            </idk-div>
          )}
          <idk-div
            style={{
              // maxWidth:
              //   isGoogle && layout?.googleBadges?.showBadge
              //     ? !mobileView
              //       ? `calc(100vw - 350px)`
              //       : `calc(100vw - 32px)`
              //     : '100vw',
              height: '100%',
            }}
          >
            <Swiper
              modules={[Navigation, Autoplay, Pagination]}
              spaceBetween={!layout?.sliderSettings?.specialCarousel ? 20 : 0}
              centeredSlides={
                layout?.sliderSettings?.centeredSlides === undefined
                  ? albumData.length > layout?.galleryInformation?.columns
                    ? true
                    : false
                  : layout?.sliderSettings?.centeredSlides
                  ? true
                  : false
              }
              slidesPerView={1}
              autoplay={
                galleryData.sliderSettings.autoPlay == false
                  ? false
                  : {
                      delay: galleryData.sliderSettings.autoPlaySpeed,
                      disableOnInteraction: false,
                    }
              }
              loop={albumData.length > layout?.galleryInformation?.columns ? true : false}
              pagination={false}
              onSlideChange={handleSlideChange}
              // swipeToSlide={true}
              onInit={(swiper) => setActiveIndex(swiper.realIndex)}
              navigation={{
                nextEl: '.google-review .image-swiper-button-next',
                prevEl: '.google-review .image-swiper-button-prev',
                disabledClass: 'swiper-button-disabled',
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1.25,
                  loop: true,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: layout?.galleryInformation?.columns || 3,
                },
              }}
            >
              {layout?.aiSummary?.enabled && (
                <SwiperSlide>
                  <AiSummaryCard metaJson={data?.result?.metaJson} layout={layout} />
                </SwiperSlide>
              )}
              {albumData.map((row, id) => {
                return (
                  <SwiperSlide key={id} style={{ height: 'auto' }}>
                    <idk-div
                      class="zid-flex zid-items-center zid-justify-center"
                      style={{
                        height: '100%',
                        flexGrow: 1,
                        borderRadius: layout?.cardSettings?.cardBorder,
                      }}
                    >
                      <GoogleView data={row} />
                    </idk-div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
            {(albumData.length > layout?.galleryInformation?.columns || window?.screen?.width < 576) && (
              <idk-div class="google-review">
                <idk-div
                  class={`zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col ${
                    layout?.sliderSettings?.arrowPosition == 'center' ? 'zid-left-[-15px]' : ''
                  } ${layout?.sliderSettings?.arrowPosition == 'outside' ? 'zid-left-[-45px]' : ''} ${
                    layout?.sliderSettings?.arrowPosition == 'inside' ? 'zid-left-[20px]' : ''
                  }`}
                  style={{ top: '50%', transform: 'translateY(-50%)' }}
                >
                  <idk-div
                    style={{ backgroundColor: layout?.sliderSettings?.arrowBackgroundColor }}
                    // style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgb(0, 0, 0)' }}
                    class="image-swiper-button-prev zid-cursor-pointer zid-bg-[#090a0b33] zid-shadow-lg zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                  >
                    <MdKeyboardArrowLeft color={layout?.sliderSettings?.arrowColor} fontSize={30} />
                  </idk-div>
                </idk-div>
                <idk-div
                  class={`zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col ${
                    layout?.sliderSettings?.arrowPosition == 'center' ? 'zid-right-[-15px]' : ''
                  } ${layout?.sliderSettings?.arrowPosition == 'outside' ? 'zid-right-[-45px]' : ''} ${
                    layout?.sliderSettings?.arrowPosition == 'inside' ? 'zid-right-[20px]' : ''
                  }`}
                  style={{ top: '50%', transform: 'translateY(-50%)' }}
                >
                  <idk-div
                    style={{ backgroundColor: layout?.sliderSettings?.arrowBackgroundColor }}
                    // style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgb(0, 0, 0)' }}
                    class="image-swiper-button-next zid-cursor-pointer zid-bg-[#090a0b33] zid-shadow-lg zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                  >
                    <MdKeyboardArrowRight color={layout?.sliderSettings?.arrowColor} fontSize={30} />
                  </idk-div>
                </idk-div>
              </idk-div>
            )}
          </idk-div>
        </idk-div>
      </React.Fragment>
    );
  }

  if (isLinkedIn) {
    return (
      <React.Fragment>
        <style>{`
      .idk-carousel2-item{
        padding: 0 ${parseInt(layout?.galleryInformation?.postSpacing) / 2}px;
      }`}</style>
        <idk-div
          style={{
            gap: `${layout?.galleryInformation?.postSpacing}px`,
          }}
        >
          <idk-div
            style={{
              maxWidth:
                isGoogle && layout?.googleBadges?.showBadge
                  ? !mobileView
                    ? `calc(100vw - 350px)`
                    : `calc(100vw - 32px)`
                  : '100vw',
              height: '100%',
            }}
          >
            <Swiper
              modules={[Navigation, Autoplay, Pagination]}
              spaceBetween={!layout?.sliderSettings?.specialCarousel ? 20 : 0}
              centeredSlides={albumData.length > layout?.galleryInformation?.columns ? true : false}
              slidesPerView={1}
              autoplay={
                galleryData.sliderSettings.autoPlay == false
                  ? false
                  : {
                      delay: galleryData.sliderSettings.autoPlaySpeed,
                      disableOnInteraction: false,
                    }
              }
              loop={albumData.length > layout?.galleryInformation?.columns ? true : false}
              pagination={false}
              onSlideChange={handleSlideChange}
              // swipeToSlide={true}
              onInit={(swiper) => setActiveIndex(swiper.realIndex)}
              navigation={{
                nextEl: '.image-swiper-button-next',
                prevEl: '.image-swiper-button-prev',
                disabledClass: 'swiper-button-disabled',
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1.25,
                  loop: true,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: layout?.galleryInformation?.columns || 3,
                },
              }}
            >
              {albumData.map((row, id) => {
                return (
                  <SwiperSlide key={id}>
                    <idk-div
                      key={id}
                      class="zid-flex zid-justify-center"
                      style={{
                        height: '100%',
                        flexGrow: 1,
                        borderRadius: layout?.cardSettings?.cardBorder,
                      }}
                    >
                      <LinkedinView data={row} />
                    </idk-div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </idk-div>
        </idk-div>
      </React.Fragment>
    );
  }

  if (albumData.length > 0) {
    return (
      <>
        <style>
          {`.swiper-container {
                width: 100%;
                padding: 0;
                height: auto;
              }
              .swiper-container .swiper-wrapper {
                padding: 20px 0;
              }
              .special-carousel .swiper-slide {
                transform: scale(0.85);
                opacity: 0.7;
                transition: all 0.4s ease;
              }
              .special-carousel .swiper-slide-active {
                transform: scale(1);
                opacity: 1;
                z-index: 2;
              }
              .swiper-slide {
                height: auto;
                max-height: 100%;
              }
              `}
        </style>

        <div className={`swiper-container ${layout?.sliderSettings?.specialCarousel ? 'special-carousel' : ''}`}>
          <Swiper
            key="album-swiper"
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            modules={[Navigation, Autoplay, Pagination]}
            spaceBetween={!layout?.sliderSettings?.specialCarousel ? 20 : 0}
            centeredSlides={
              galleryData?.sliderSettings?.centeredSlides !== undefined
                ? galleryData?.sliderSettings?.centeredSlides
                : albumData.length > layout?.galleryInformation?.columns
                ? true
                : false
            }
            slidesPerView={1}
            autoplay={
              galleryData.sliderSettings.autoPlay == false
                ? false
                : {
                    delay: galleryData.sliderSettings.autoPlaySpeed,
                    disableOnInteraction: false,
                  }
            }
            loop={albumData.length > layout?.galleryInformation?.columns ? true : false}
            pagination={false}
            onSlideChange={(swiper) => {
              swiperRef.current = swiper;
              handleSlideChange(swiper);
            }}
            onInit={(swiper) => setActiveIndex(swiper.realIndex)}
            navigation={{
              nextEl: '.image-swiper-button-next',
              prevEl: '.post-slider .image-swiper-button-prev',
              disabledClass: 'swiper-button-disabled',
            }}
            breakpoints={{
              0: {
                slidesPerView: 1.5,
                loop: true,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: layout?.galleryInformation?.columns || 3,
              },
            }}
          >
            {albumData.slice(0, 1).map((row, id) => (
              <SwiperSlide
                style={{
                  borderRadius: layout?.cardSettings?.cardBorder,
                }}
                key={id}
                id={`slide_0`}
                className={`zid-relative zid-w-full carousel2-item zid-pt-2`}
              >
                <idk-div
                  class={`zid-w-full idk-slide-content zid-flex zid-flex-col zid-transition-all zid-duration-300 zid-ease-out  ${
                    layout?.sliderSettings?.specialCarousel ? '' : 'hover:zid-scale-[1.03]'
                  }`}
                  onClick={() => {
                    showModal(row, 'slider');
                    setAlbumId(row.id);
                    clickMutate(row.id, {
                      event: row.mediaType === SOURCE_TYPES.VIDEO ? CLICK_EVENTS.VIDEO_WATCH : CLICK_EVENTS.IMG_CLICK,
                    });
                  }}
                  style={{
                    borderRadius: layout?.cardSettings?.cardBorder,
                    height: '100%',
                    border: `1px solid ${layout?.cardSettings?.cardBorderColor}`,
                  }}
                >
                  <HotspotMedia
                    row={row}
                    playFunctionality={false}
                    autoPlay={
                      id < activeIndex + 3 || id >= albumData.length - 2 ? layout?.videoSettings?.videoAutoPlay : false
                    }
                    preload={id < activeIndex + 3 || id >= albumData.length - 2 ? 'auto' : 'metadata'}
                    layout={layout}
                    style={{ borderRadius: layout?.cardSettings?.cardBorder }}
                  />
                  {layout?.sliderSettings?.specialCarousel
                    ? row?.products?.length > 0 &&
                      layout.gallerySettings.showProducts && (
                        <idk-div class="zid-h-[110px] zid-shrink-0">
                          <ProductOutsideUp shopifyData={shopifyData} row={row} />
                        </idk-div>
                      )
                    : row?.products?.length > 0 &&
                      layout.gallerySettings.showProducts && (
                        <idk-div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                          <ProductOutside shopifyData={shopifyData} row={row} />
                        </idk-div>
                      )}
                </idk-div>
              </SwiperSlide>
            ))}
            {layout?.gallerySiteUploads?.buttonShow && layout?.gallerySiteUploads?.buttonStyle === 'tile' && (
              <SwiperSlide
                style={{
                  borderRadius: layout?.cardSettings?.cardBorder,
                  height: 'auto',
                }}
                className={`zid-p-5 zid-relative zid-bg-gray-200 zid-w-full carousel2-item idk-site-uploads-card`}
              >
                <idk-div class="zid-text-xl zid-text-center zid-flex zid-items-center zid-justify-center zid-flex-col zid-h-full zid-w-full zid-gap-2">
                  <idk-div
                    class="zid-font-bold"
                    dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addSvg }}
                  ></idk-div>
                  <idk-div
                    class="zid-font-bold"
                    dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addDescriptionText }}
                  ></idk-div>
                  <idk-div
                    onClick={() => setIsUploadModalOpen(true)}
                    className="zid-flex zid-items-center zid-gap-2 zid-cursor-pointer zid-px-3 zid-py-1"
                    dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addButtonText }}
                  ></idk-div>
                </idk-div>
              </SwiperSlide>
            )}
            {albumData.slice(1).map((row, id) => (
              <SwiperSlide
                style={{
                  borderRadius: layout?.cardSettings?.cardBorder,
                }}
                key={id}
                id={`slide_${id + 1}`}
                className={`zid-relative zid-w-full carousel2-item zid-pt-2`}
              >
                <idk-div
                  class={`zid-w-full idk-slide-content zid-flex zid-flex-col zid-transition-all zid-duration-300 zid-ease-out ${
                    layout?.sliderSettings?.specialCarousel ? '' : 'hover:zid-scale-[1.03]'
                  }`}
                  onClick={() => {
                    showModal(row, 'slider');
                    setAlbumId(row.id);
                    clickMutate(row.id, {
                      event: row.mediaType === SOURCE_TYPES.VIDEO ? CLICK_EVENTS.VIDEO_WATCH : CLICK_EVENTS.IMG_CLICK,
                    });
                  }}
                  style={{
                    borderRadius: layout?.cardSettings?.cardBorder,
                    height: '100%',
                    border: `1px solid ${layout?.cardSettings?.cardBorderColor}`,
                  }}
                >
                  <HotspotMedia
                    row={row}
                    playFunctionality={false}
                    autoPlay={
                      id < activeIndex + 3 || id >= albumData.length - 2 ? layout?.videoSettings?.videoAutoPlay : false
                    }
                    preload={id < activeIndex + 3 || id >= albumData.length - 3 ? 'auto' : 'none'}
                    layout={layout}
                    style={{ borderRadius: layout?.cardSettings?.cardBorder }}
                  />
                  {layout?.sliderSettings?.specialCarousel
                    ? row?.products?.length > 0 &&
                      layout.gallerySettings.showProducts && (
                        <idk-div class="zid-h-[110px] zid-shrink-0">
                          <ProductOutsideUp shopifyData={shopifyData} row={row} />
                        </idk-div>
                      )
                    : row?.products?.length > 0 &&
                      layout.gallerySettings.showProducts && <ProductOutside shopifyData={shopifyData} row={row} />}
                </idk-div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {(albumData.length > layout?.galleryInformation?.columns || window?.screen?.width < 576) && (
          <>
            <idk-div
              class={`post-slider zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col ${
                layout?.sliderSettings?.arrowPosition == 'center' ? 'zid-left-[-15px]' : ''
              } ${layout?.sliderSettings?.arrowPosition == 'outside' ? 'zid-left-[-45px]' : ''} ${
                layout?.sliderSettings?.arrowPosition == 'inside' ? 'zid-left-[20px]' : ''
              }`}
              style={{ top: '50%', transform: 'translateY(-50%)' }}
            >
              <idk-div
                style={{ backgroundColor: layout?.sliderSettings?.arrowBackgroundColor }}
                // style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgb(0, 0, 0)' }}
                class="image-swiper-button-prev zid-cursor-pointer zid-bg-[#090a0b33] zid-shadow-lg zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
              >
                <MdKeyboardArrowLeft color={layout?.sliderSettings?.arrowColor} fontSize={30} />
              </idk-div>
            </idk-div>
            <idk-div
              class={`zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col ${
                layout?.sliderSettings?.arrowPosition == 'center' ? 'zid-right-[-15px]' : ''
              } ${layout?.sliderSettings?.arrowPosition == 'outside' ? 'zid-right-[-45px]' : ''} ${
                layout?.sliderSettings?.arrowPosition == 'inside' ? 'zid-right-[20px]' : ''
              }`}
              style={{ top: '50%', transform: 'translateY(-50%)' }}
            >
              <idk-div
                style={{ backgroundColor: layout?.sliderSettings?.arrowBackgroundColor }}
                // style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgb(0, 0, 0)' }}
                class="image-swiper-button-next zid-cursor-pointer zid-bg-[#090a0b33] zid-shadow-lg zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
              >
                <MdKeyboardArrowRight color={layout?.sliderSettings?.arrowColor} fontSize={30} />
              </idk-div>
            </idk-div>
          </>
        )}
      </>
    );
  } else {
    return (
      <>
        {layout?.gallerySiteUploads?.buttonShow && layout?.gallerySiteUploads?.buttonStyle === 'tile' && (
          <SwiperSlide
            style={{
              borderRadius: layout?.cardSettings?.cardBorder,
              height: 'auto',
            }}
            className={`zid-p-5 zid-relative zid-bg-gray-200 zid-w-full carousel2-item`}
          >
            <idk-div class="zid-text-xl zid-text-center zid-flex zid-items-center zid-justify-center zid-flex-col zid-h-full zid-w-full zid-gap-2">
              <idk-div
                class="zid-font-bold"
                dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addSvg }}
              ></idk-div>
              <idk-div
                class="zid-font-bold"
                dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addDescriptionText }}
              ></idk-div>
              <idk-div
                onClick={() => setIsUploadModalOpen(true)}
                className="zid-flex zid-items-center zid-gap-2 zid-cursor-pointer zid-px-3 zid-py-1"
                dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addButtonText }}
              ></idk-div>
            </idk-div>
          </SwiperSlide>
        )}
      </>
    );
  }
};

export function LeftArrow({ ...props }) {
  const { onClick } = props;
  const {
    carouselState: { currentSlide },
  } = props;

  if (currentSlide == 0) return <></>;

  return (
    <idk-div
      style={{ width: '30px', height: '30px', backgroundColor: 'rgba(0,0,0,0.5)' }}
      onClick={onClick}
      class={`idk_carasourl_arrow idk_carasourl_arrow_left zid-absolute zid-translate-y-[-50%] zid-top-[50%] zid-translate-x-[20px] zid-cursor-pointer zid-rounded-full zid-opacity-[0.7] zid-h-[36px] zid-w-[36px] zid-flex zid-items-center zid-justify-center`}
    >
      <svg height="20px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="20px" fill="#ffffff">
        <polygon points="352,115.4 331.3,96 160,256 331.3,416 352,396.7 201.5,256 " />
      </svg>
    </idk-div>
  );
}

export function RightArrow({ ...props }) {
  const { onClick, totalSlides } = props;
  const {
    carouselState: { currentSlide },
  } = props;

  if (currentSlide == totalSlides - 1) return <></>;
  return (
    <idk-div
      style={{ width: '30px', height: '30px', backgroundColor: 'rgba(0,0,0,0.5)' }}
      onClick={onClick}
      class={`idk_carasourl_arrow idk_carasourl_arrow_right zid-absolute zid-translate-y-[-50%] zid-right-0 zid-top-[50%] zid-translate-x-[-20px] zid-z-[100] zid-cursor-pointer zid-rounded-[99px] zid-opacity-[0.7] zid-h-[36px] zid-w-[36px] zid-flex zid-items-center zid-justify-center`}
    >
      <svg height="20px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="20px" fill="#ffffff">
        <polygon points="160,128.4 192.3,96 352,256 352,256 352,256 192.3,416 160,383.6 287.3,256 " />
      </svg>
    </idk-div>
  );
}

export default memo(CarouselTwo);
